import { FunctionComponent, memo } from 'react';
import { StoryCardArticleContent } from '../../../services';
import { FeedCardProps } from '../../../shared';
import { FeedCardPreviewContent } from '../FeedCardPreviewContent';
import { FeedCardPreviewWrapper } from '../FeedCardPreviewWrapper';

export const FeedCardPreviewArticle: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  const { type, content } = card;
  const { title, sourceName, abstract } = content as StoryCardArticleContent;

  return (
    <FeedCardPreviewWrapper card={card}>
      <FeedCardPreviewContent
        cardType={type}
        source={sourceName}
        title={title}
        text={abstract}
      ></FeedCardPreviewContent>
    </FeedCardPreviewWrapper>
  );
});
